import { ReactNode } from 'react';
import { createPortal } from 'react-dom';

// Wrapper to render React components onto the DOM
// which lives outside of React (e.g. Google Maps Canvas)

interface PortalProps {
  target: HTMLElement;
  children: ReactNode;
}

const Portal = ({ target, children }: PortalProps) => {
  return createPortal(children, target);
};

export default Portal;
